export default __webpack_public_path__ + "static/media/edit-note.6d89e168.svg";